import { useState } from "react";
import { useCart } from "../Context/CartContext";
import { parsePrice } from "../utils/price";
import { generateOrderId } from "../utils/orderId";

export default function Checkout() {
  const { cart } = useCart();
  const [submitted, setSubmitted] = useState(false);
  const [orderId, setOrderId] = useState<string | null>(null);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
  });

  const subtotal = cart.reduce(
    (sum, item) => sum + parsePrice(item.price) * item.quantity,
    0
  );

  if (cart.length === 0) {
    return (
      <div className="container">
        <h2>Your cart is empty</h2>
      </div>
    );
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const id = generateOrderId();

    const order = {
      orderId: id,
      date: new Date().toISOString(),
      items: cart,
      subtotal,
    };

    const existing = JSON.parse(localStorage.getItem("orders") || "[]");
    localStorage.setItem("orders", JSON.stringify([order, ...existing]));

    setOrderId(id);
    setSubmitted(true);
  };

  if (submitted && orderId) {
    return (
      <div className="container">
        <h1>Order Received ✅</h1>

        <p>
          <strong>Order ID:</strong> {orderId}
        </p>

        <p>Thank you! Your order details have been recorded.</p>

        <p>
          <strong>Order Amount:</strong> ₹{subtotal}
        </p>
      </div>
    );
  }

  return (
    <div className="container checkout">
      <h1>Checkout</h1>

      <form className="checkout-grid" onSubmit={handleSubmit}>
        {/* Address */}
        <div className="card">
          <h3>Shipping Address</h3>

          <input
            name="name"
            placeholder="Full Name"
            value={form.name}
            onChange={handleChange}
            required
          />
          <input
            name="phone"
            placeholder="Mobile Number"
            value={form.phone}
            onChange={handleChange}
            required
          />
          <input
            name="address"
            placeholder="Address Line"
            value={form.address}
            onChange={handleChange}
            required
          />
          <input
            name="city"
            placeholder="City"
            value={form.city}
            onChange={handleChange}
            required
          />
          <input
            name="state"
            placeholder="State"
            value={form.state}
            onChange={handleChange}
            required
          />
          <input
            name="pincode"
            placeholder="Pincode"
            value={form.pincode}
            onChange={handleChange}
            required
          />
        </div>

        {/* Order Summary */}
        <div className="card">
          <h3>Order Summary</h3>

          {cart.map((item) => (
            <div key={item.id} className="summary-row">
              <span>
                {item.name} × {item.quantity}
              </span>
              <span>₹{parsePrice(item.price) * item.quantity}</span>
            </div>
          ))}

          <hr />

          <div className="summary-row total">
            <strong>Subtotal</strong>
            <strong>₹{subtotal}</strong>
          </div>

          <button type="submit">Place Order</button>

          <small>Connect us on our phone for Payment.</small>
        </div>
      </form>
    </div>
  );
}
